import React from 'react'
import './testimonials.css'
import ReignB3 from '../../acesset/ReignB3.png'
import ReignB6 from '../../acesset/ReignB0.png'
import ReignB8 from '../../acesset/ReignB.png'
import abdul from '../../acesset/abdul.jpg'
import Abdulsallam from '../../acesset/Abdulsallam.jpg'
import ahmad from '../../acesset/ahmad.jpg'
import Ahmed from '../../acesset/Ahmed.jpg'
import emma from '../../acesset/emma.jpg'
import teo from '../../acesset/teo.jpg'
import ogamur from '../../acesset/ogamur.jpg'

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';

// Import Swiper core and required modules
import { Pagination, Autoplay, EffectFade } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

const data = [
  {
    avatar: ReignB8,  
    name: 'ReignB',
    role: 'Product Manager',
    company: 'Tech Solutions Inc.',
    review: 'Working with Sadiq was an absolute pleasure. His expertise in full-stack development and ability to deliver complex healthcare systems on time is remarkable. The solution he built saved our team countless hours.',
    rating: 5
  },
  {
    avatar: ReignB6,  
    name: 'Ahmad Azkiama',
    role: 'CTO',
    company: 'HealthTech Innovations',
    review: 'Exceptional work! Sadiq delivered a robust enterprise solution that exceeded our expectations. His attention to detail and technical expertise are outstanding.',
    rating: 5
  },
  {
    avatar: ReignB3,  
    name: 'XXX Tentacion',
    role: 'Lead Developer',
    company: 'Digital Agency',
    review: 'Sadiq is a true professional. His code quality and problem-solving skills are top-notch. Highly recommended for any complex project.',
    rating: 5
  },
  {
    avatar: abdul,
    name: 'Abdullahi',
    role: 'Project Manager',
    company: 'Enterprise Solutions',
    review: 'Outstanding developer with excellent communication skills. Sadiq transformed our legacy system into a modern, scalable application. His dedication to quality is impressive.',
    rating: 5
  },
  {
    avatar: teo,
    name: 'Theophilious',
    role: 'Senior Engineer',
    company: 'Cloud Systems',
    review: 'Sadiq\'s expertise in React and Node.js is exceptional. He delivered our healthcare management system ahead of schedule with zero critical bugs. A true professional.',
    rating: 5
  },
  {
    avatar: ogamur,
    name: 'Murtala',
    role: 'Technical Lead',
    company: 'Software House',
    review: 'Working with Sadiq was a game-changer for our project. His ability to understand complex requirements and deliver elegant solutions is remarkable.',
    rating: 5
  },
  {
    avatar: Abdulsallam,
    name: 'Abdulsallam Abubakar',
    role: 'CEO',
    company: 'Startup Ventures',
    review: 'Sadiq built our entire platform from scratch. His technical skills, combined with his business understanding, made him an invaluable partner. Highly recommended!',
    rating: 5
  },
  {
    avatar: ahmad,
    name: 'Ahmad Abubakar',
    role: 'DevOps Engineer',
    company: 'Cloud Infrastructure',
    review: 'Excellent collaboration! Sadiq\'s code is clean, well-documented, and easy to maintain. His AWS expertise helped us scale our application seamlessly.',
    rating: 5
  },
  {
    avatar: Ahmed,
    name: 'Ahmed',
    role: 'Product Owner',
    company: 'Healthcare Systems',
    review: 'It\'s been a great experience working with Sadiq. He delivered a production-grade healthcare system that serves thousands of users daily. Professional and reliable.',
    rating: 5
  },
  {
    avatar: emma,
    name: 'Emmanuel',
    role: 'Tech Director',
    company: 'Digital Solutions',
    review: 'Sadiq is one of the best developers I\'ve worked with. His full-stack expertise and problem-solving abilities are exceptional. Would definitely work with him again!',
    rating: 5
  }
] 

const Testimonials = () => {
  return (
    <section id='testimonials'>
      <h5>Review From Clients</h5>
      <h2>Testimonials</h2> 
      <p className="testimonials__subtitle">
        What clients and colleagues say about working with me
      </p>

      <Swiper
        className='container testimonials__container'
        modules={[Pagination, Autoplay, EffectFade]}
        spaceBetween={40}
        slidesPerView={1}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        pagination={{ 
          clickable: true,
          dynamicBullets: true 
        }}
        autoplay={{
          delay: 5000, 
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        speed={800}
        loop={true}
      >
        {data.map(({ avatar, name, role, company, review, rating }, index) => (
          <SwiperSlide key={index} className='testimonial'>
            <div className='client__avatar'>
              <img alt={name} src={avatar} />
            </div>
            
            <div className="testimonial__rating">
              {[...Array(rating)].map((_, i) => (
                <span key={i} className="star">★</span>
              ))}
            </div>

            <h5 className='client__name'>{name}</h5>
            <p className='client__role'>{role}</p>
            <p className='client__company'>{company}</p>
            
            <small className='client__review'>{review}</small>

            <div className="testimonial__quote-icon">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                <path d="M10 20C10 15 12 10 18 8V12C14 13 12 15 12 18H18V28H10V20Z" fill="currentColor" opacity="0.2"/>
                <path d="M22 20C22 15 24 10 30 8V12C26 13 24 15 24 18H30V28H22V20Z" fill="currentColor" opacity="0.2"/>
              </svg>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="testimonials__stats">
        <div className="stat">
          <h3>25+</h3>
          <p>Happy Clients</p>
        </div>
        <div className="stat">
          <h3>38+</h3>
          <p>Projects Delivered</p>
        </div>
        <div className="stat">
          <h3>100%</h3>
          <p>Satisfaction Rate</p>
        </div>
      </div>
    </section>
  )
}

export default Testimonials
